import baseConfig from 'hsi/configurations/cision/config';
import {AppConfigType} from 'hsi/types/config';

const config: AppConfigType = {
    ...baseConfig,
    appSource: 'C3',
} as const;

export default config;
